import { useAuth } from "../context/AuthContext.jsx";

/** Stable auth identity for data hooks — null while loading or signed out. */
export function useAuthUserId() {
  const { user, status } = useAuth();
  const authLoading = status === "loading";
  const userId =
    status === "authenticated" && user?.$id ? String(user.$id) : null;
  return { userId, authLoading, status };
}
